var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 406 114",
    style: {
      enableBackground: "new 0 0 406 114"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#151D30;}\n\t.st1{fill:#3F62FE;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M92.3,34.4h-19v50H58v-50l0,0V20.2l34.3,0V34.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M24.1,34.4H22c-3.3,0-6-2.7-6-6v-2.1c0-3.3,2.7-6,6-6h2.1c3.3,0,6,2.7,6,6v2.1C30.2,31.7,27.5,34.4,24.1,34.4 z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M51.1,60.3c0,16.9-9.6,25.3-23.7,25.3c-10,0-16.8-4-20.4-8l8-11.6c2.5,2.6,6.1,4.9,11.3,4.9 c6,0,9.5-3.4,9.5-11.9V39.3h15.3V60.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M44.5,34.4h-2.1c-3.3,0-6-2.7-6-6v-2.1c0-3.3,2.7-6,6-6h2.1c3.3,0,6,2.7,6,6v2.1 C50.5,31.7,47.8,34.4,44.5,34.4z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M123.4,38.9L122,53.2c-1.9-0.6-4.6-1.2-7.2-1.2c-5.1,0-8.2,2.5-8.2,8.1v24.3H92.3v-45H106v5.2 c2.6-4.4,6.8-6.4,12.3-6.4C120.4,38.2,122.3,38.5,123.4,38.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M173.2,84.4h-13.9v-4.9c-2.7,3.5-6.8,6.1-12.9,6.1c-12,0-20.9-10.5-20.9-23.7c0-13.2,8.9-23.7,21-23.7 c6.1,0,10.2,2.6,12.9,6.1v-4.9h13.9V84.4z M140.2,61.9c0,5.9,3.9,10.3,9.6,10.3c5.6,0,9.6-4.4,9.6-10.3c0-6-4-10.3-9.6-10.3 C144,51.6,140.2,56,140.2,61.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M223.4,48l-11.2,7.8c-2.2-2.9-4.8-4.3-8.3-4.3c-5,0-9.3,3.9-9.3,10.3c0,6.5,4.2,10.3,9.2,10.3 c3.4,0,6.2-1.5,8.5-4.4l11.2,8c-4.3,6.1-10.9,9.8-19.3,9.8c-14.3,0-24.3-9.9-24.3-23.7s9.9-23.7,24.3-23.7 C212.5,38.2,219.1,41.9,223.4,48z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M243.3,54.3h3.4l10.6-14.9h17.4l-16.6,21.2l16.7,23.7h-17.3L246.4,67h-3.1v17.4H229v-66h14.4V54.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M293.1,84.4h-14.4v-45h14.4V84.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M345.3,54.9v29.5h-14.4V59.9c0-5.3-2.7-8.3-7.1-8.3c-4,0-7.3,2.7-7.3,8.5v24.2h-14.4v-45h13.8V45 c2.8-4.7,7.4-6.9,13.4-6.9C338.3,38.2,345.3,44.4,345.3,54.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M385.2,44.1v-4.7h13.9v40.7c0,14.8-9.7,23.6-24.4,23.6c-7.5,0-15.2-1.9-20.5-5.7l5.1-11.4 c4.4,3.1,9.1,4.6,14.4,4.6c5.8,0,11.3-3.2,11.3-10.4v-2.8c-2.7,3.4-6.6,5.7-12.4,5.7c-12.1,0-20.9-9.9-20.9-22.7 s8.8-22.7,20.9-22.7C378.5,38.2,382.5,40.6,385.2,44.1z M366.6,60.9c0,5.5,3.9,9.6,9.4,9.6c5.4,0,9.2-4.1,9.2-9.6 s-3.8-9.6-9.2-9.6C370.4,51.3,366.6,55.4,366.6,60.9z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M286.9,34.4h-2.1c-3.3,0-6-2.7-6-6v-2.1c0-3.3,2.7-6,6-6h2.1c3.3,0,6,2.7,6,6v2.1 C293,31.7,290.3,34.4,286.9,34.4z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.d50139ce44e1f0ca67d679bd79296622.svg";
export { ForwardRef as ReactComponent };